import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';

interface BannerStripProps {
  text: string;
  btnText: string;
  link: string;
}

const BannerStrip = ({ text, btnText, link }: BannerStripProps) => {
  const navigate = useNavigate();

  return (
    <Container>
      <Content>
        <Message>{text}</Message>
        <Button onClick={() => navigate(link)}>{btnText}</Button>
      </Content>
    </Container>
  );
};

export default BannerStrip;


const Container = styled.div`
  background-color: #000;
  padding: 12px 24px;
  width: 100%;
`;

const Content = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;

  @media (max-width: 600px) {
    justify-content: space-between;
    text-align: center;
    flex-wrap: nowrap;
  }
`;

const Message = styled.p`
  color: #fff;
  font-size: 14px;
  font-weight: 400;

    @media (max-width: 600px) {
    font-size: 12px;
   text-align: left;
  }
`;

const Button = styled.button`
  background-color: ${({ theme }) => theme.palette.redFontColor};
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  padding: 6px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  white-space:nowrap;

  &:hover {
    background-color: ${({ theme }) => theme.palette.redHoverFontColor};
  }
`;
